import Navbar from '../../components/public/Navbar';
import TickerBanner from '../../components/public/TickerBanner';
import HeroSection from '../../components/public/HeroSection';
import MyPartners from '../../components/public/MyPartners';
import MedicalPartners from '../../components/public/MedicalPartners';
import ServingGurgaon from '../../components/public/ServingGurgaon';
import SiteBanner from '../../components/public/SiteBanner';
import HowItWorks from '../../components/public/HowItWorks';
import BrandPromise from '../../components/public/BrandPromise';
import CatalogueTeaser from '../../components/public/CatalogueTeaser';
import WhySection from '../../components/public/WhySection';
import Testimonials from '../../components/public/Testimonials';
import AppPreview from '../../components/public/AppPreview';
import FAQSection from '../../components/public/FAQSection';
import CallbackForm from '../../components/public/CallbackForm';
import ContactSection from '../../components/public/ContactSection';
import Footer from '../../components/public/Footer';

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navbar />
      <TickerBanner />
      <HeroSection />
      <MyPartners />
      <MedicalPartners />
      <ServingGurgaon />
      <SiteBanner />
      <HowItWorks />
      <BrandPromise />
      <CatalogueTeaser />
      <WhySection />
      <Testimonials />
      <AppPreview />
      <FAQSection />
      <CallbackForm />
      <ContactSection />
      <Footer />
    </div>
  );
}
